import { useState, useEffect, useCallback } from "react";
import { supabase } from "../lib/supabase";

export interface KoreanBriefSettings {
  id: string;
  widget_title: string;
  widget_subtitle: string;
  widget_logo_url: string;
  widget_logo_x: number;
  widget_logo_y: number;
  widget_logo_scale: number;
  widget_article_count: number;
  widget_font_family: string;
  widget_font_size: number;
  widget_desc_font_family: string;
  widget_desc_font_size: number;
  banner_cover_url: string;
  banner_title: string;
  banner_title_highlight: string;
  banner_description: string;
  banner_slogan: string;
  // Banner has its own separate logo
  banner_logo_url: string;
  banner_logo_x: number;
  banner_logo_y: number;
  banner_logo_scale: number;
}

const DEFAULT_SETTINGS: KoreanBriefSettings = {
  id: "default",
  widget_title: "Korean Brief",
  widget_subtitle: "Điểm tin Hàn Quốc",
  widget_logo_url: "",
  widget_logo_x: 50,
  widget_logo_y: 50,
  widget_logo_scale: 1.0,
  widget_article_count: 4,
  widget_font_family: "inherit",
  widget_font_size: 16,
  widget_desc_font_family: "inherit",
  widget_desc_font_size: 13,
  banner_cover_url: "",
  banner_title: "Korean Brief Daily",
  banner_title_highlight: "Daily",
  banner_description: "Tin tức kinh tế & công nghệ Hàn Quốc cập nhật hàng ngày dành cho người Việt",
  banner_slogan: "Bizwell",
  banner_logo_url: "",
  banner_logo_x: 50,
  banner_logo_y: 50,
  banner_logo_scale: 1.0,
};

export const useKoreanBriefSettings = () => {
  const [settings, setSettings] = useState<KoreanBriefSettings>(DEFAULT_SETTINGS);
  const [loading, setLoading] = useState(true);

  const fetchSettings = useCallback(async () => {
    setLoading(true);
    const { data } = await supabase
      .from("korean_brief_settings")
      .select("*")
      .eq("id", "default")
      .maybeSingle();
    if (data) {
      setSettings({ ...DEFAULT_SETTINGS, ...data });
    }
    setLoading(false);
  }, []);

  useEffect(() => {
    fetchSettings();
  }, [fetchSettings]);

  const saveSettings = async (updated: Partial<KoreanBriefSettings>): Promise<boolean> => {
    const payload = { ...settings, ...updated, id: "default", updated_at: new Date().toISOString() };
    const { error } = await supabase
      .from("korean_brief_settings")
      .upsert(payload, { onConflict: "id" });
    if (!error) {
      setSettings(payload);
      return true;
    }
    return false;
  };

  return { settings, loading, fetchSettings, saveSettings };
};
